import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import BackButton from "../../components/BackButton";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import { PlusCircleIcon } from "@heroicons/react/outline";
import Paginate from "../../utils/Paginate";
import { Link } from "react-router-dom";
import service from "../../services/complianceSheetServices"

const Index = () => {
  const [user, setUsers] = useState([]);
  const [search, searchUser] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState('')
  const [to, setTo] = useState("")

  const getAllAccountonPnd = async (
    page,
    pageLimit,
    searchItem,
    startDate,
    endDate
  ) => {
    const response = await service.listComplicancePnd(
      page,
      pageLimit,
      searchItem,
      startDate,
      endDate
    );
    if (response) {
      setUsers([...response.data.result]);
      setPageNumber(response.data.totalCount);
      setPageIndex(response.data.pageIndex);
      setPrev(response.data.hasPreviousPage);
      setNextPage(response.data.hasNextPage);
      setPage(response.data.totalPages);
    }
  }
  useEffect(() => {
    getAllAccountonPnd(pageIndex, 10, search, from, to);
  }, [pageIndex])

  const searchUsers = () => {
    getAllAccountonPnd(pageIndex, 10, search, from, to);
  };




  return (
    <Layout
      title="Compliance Sheet"
      pageTag={"compliance"}
      current={"/compliance/sheets"}
    >
      <React.Fragment>
        <main>
          <div className="max-w-7xl mx-auto">
            <BackButton />
          </div>
          <div className="w-full px-4 sm:px-6 md:px-8 mt-10">
            <div className="">
              <div className="sm:flex-auto flex justify-between">
                <div className="flex">
                  <div className="mt-1 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onChange={(e) => searchUser(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search Accounts"
                    />
                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                      <div className="tooltip">
                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                        <span className="tooltiptext">
                          {" "}
                          <p>Search by account number</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1 ml-4">
                    <button
                      onClick={searchUsers}
                      className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="flex items-start">
                  <Link to="/compliance/log" className="">
                    <button
                      type="button"
                      className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                    >
                      <PlusCircleIcon className="w-4 mr-1.5" />
                      Log Pnd
                    </button>
                  </Link>
                  <div></div>
                </div>
              </div>
                {user.length === 0 ? (
                    <div className="mt-8">
                    {" "}
                    No data available for these dates to show.{" "}
                    </div>
                ) : (
                    <>
                    <div className="mt-8 flex w-full">
                        <div className="-my-2 -mx-4 overflow-x-auto w-full">
                        <div className="inline-block min-w-full py-2">
                        <div className="relative overflow-auto ring-1 ring-black ring-opacity-5 md:rounded-lg w-full">
                            <table className="min-w-full divide-y divide-gray-300 w-[150%]">
                              <thead>
                                <tr>
                                    <th
                                    scope="col"
                                    className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400 sticky left-0 backdrop-blur-lg"
                                    >
                                    Account Name
                                    </th>
                                    <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                    >
                                    Account No
                                    </th>
                                   
                                    <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                    >
                                    Branch Code
                                    </th>
                                    <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                    >
                                    Account Class
                                    </th>
                                    <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                    >
                                    Pnd Status
                                    </th>
                        
                                    <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                    >
                                    Compliance reason
                                    </th>
                                    
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                  {
                                    user.map((item, index) => (
                                     <tr key={index} className="bg-gray-50">
                                      <td className="sticky left-0 backdrop-blur-lg whitespace-nowrap pr-3 py-4 text-sm pl-5 text-gray-500">
                                      {item.accountName} 
                                      </td>
                                      <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {item.accountNumber}
                                      </td>
                                      <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {item.branchCode < 10 ? "00" : "0"}{item.branchCode}
                                      </td>
                                      <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {item.accountClass}
                                      </td>
                                      <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {item.isOnPnd ? "Yes" : "No"}
                                      </td>
                                      <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {item.complianceReason}
                                      </td>
                                     </tr>   
                                    ))
                                  }
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>
                    <Paginate
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={pageNumber}
                        totalPages={totalPage}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                    />
                    </>
                )}
            </div>
          </div>
        </main>
      </React.Fragment>
    </Layout>
  );
};

export default Index;
